import React from 'react';
import ReactDOM from 'react-dom';
import App from "./App";

if (process.env.NODE_ENV !== 'production') {
  import( './only-dev.scss')
}

if (process.env.NODE_ENV === 'production') {
  import( './only-prod.scss')
}

ReactDOM.render(<App/>, document.getElementById('chrmap'));
